// Create a new file: /components/workflow/Array2ElementNode.jsx

import React from 'react';
import { Handle, Position } from 'reactflow';
import { UnfoldVertical } from 'lucide-react';

const UnwrapArrayNode = ({id, data }) => {
    const selectedArrayName = data.selectedArrayPath?.split('.').pop() || 'Not Configured';

    return (
        <div className="w-64 bg-zinc-800 border-2 border-teal-700 rounded-lg shadow-lg">
            <div className="p-3 border-b border-zinc-700 bg-zinc-900/50 rounded-t-lg flex items-center gap-3">
                <UnfoldVertical className="text-teal-400" size={20} />
                <h3 className="font-bold text-base text-white">Unwrap Array</h3> {id}
            </div>
            <div className="p-3 text-xs text-slate-300 space-y-1">
                <p className="truncate">
                    <span className="font-semibold text-slate-400">Source: </span> 
                    {selectedArrayName}
                </p>
                <p>
                    <span className="font-semibold text-slate-400">Output: </span> 
                    Single 'arrayElement'
                </p>
            </div>
            <Handle type="source" position={Position.Right} className="w-3 h-3 !bg-teal-500" />
            <Handle type="target" position={Position.Left} className="w-3 h-3 !bg-rose-500" />
        </div>
    );
};

export default UnwrapArrayNode;